<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 8 14"
>
  <path
    [attr.stroke]="color"
    d="M1 12.5L6 7L1 1.5"
    stroke-width="2"
  />
</svg>
